export default __webpack_public_path__ + "img/9c45f7689d455985ee2c83e18ee63ad7.png";